module.exports = __webpack_public_path__ + "static/media/io.2e68506a.svg";